/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPublicTile} from '../api'

 export const useQueryGetPublicTile = createReactQueryHook('getPublicTile', getPublicTile)
